module.exports = __webpack_public_path__ + "product_search_commission-75a3f8cb251f1c172de4cd7c7c663077.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/common/onboarding/product_search_commission.png
// module id = 1143
// module chunks = 0 1 2 3 4